import React from 'react'
import styled from 'styled-components'

const StyledCardsContainer = styled.div.withConfig({
  shouldForwardProp: prop => !['marginBottom', 'marginTop', 'minHeight'].includes(prop)
})`
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-top: ${({ marginTop }) => marginTop || '10px'};
  min-height: ${({ minHeight }) => minHeight || ''};
  position: relative;

  & > * {
    margin-top: 10px;
  }

  @media screen and (min-width: 600px) {
    margin-top: ${({ marginTop }) => marginTop || '30px'};

    & > * {
      margin-top: 10px;

      &:first-of-type {
        margin-top: 0;
      }
    }
  }
`

const CardsContainer = ({ children, hasOverlay, marginBottom, marginTop, minHeight }) => {
  if (hasOverlay) return null

  return (
    <StyledCardsContainer
      marginBottom={marginBottom}
      marginTop={marginTop}
      minHeight={minHeight}
      id="results"
    >
      {children}
    </StyledCardsContainer>
  )
}

export default CardsContainer
